import { POST } from "../../APiHelper/API";

export const addReferee = (league_id, data, onSuccess, onError) => {
    POST(`/api/v1/leagues/${league_id}/add_referee`, data, onSuccess, onError)
}